module.exports = __webpack_public_path__ + "media/images/icons/vendors/weddingrings-8f2b32c82d855ff3bdb4f1b9d0d2d66a.png";